import { useCallback, useMemo, useState } from 'react';

import { BookingService } from '../booking-service';

const errorCodeMapping = {
  SlotNotAvailable: _TL_('Booking Time is already reserved, try another time slot'),
};

export const useBookingService = ({
  logger,
}) => {
  const bookingService = useMemo(() => BookingService(), []);

  const [isCreatingBooking, setIsCreatingBooking] = useState(false);
  const [isGetExistingBookings, setIsGetExistingBookings] = useState(false);

  const [getBookingError, setGetBookingError] = useState('');
  const [createBookingError, setCreateBookingError] = useState('');

  const [existingBookings, setExistingBookings] = useState([]);

  // Action: create a booking
  const createBooking = useCallback((props) => {
    setIsCreatingBooking(true);

    return bookingService.createBooking(props).then(res => res)
      .catch((error) => {
        const errorCode = error && error.body && error.body.errorCode;
        const errorMessage = errorCodeMapping[errorCode] || _TL_('Request failed, please try later');
        setCreateBookingError(errorMessage);

        logger.logError('Create booking failed', errorMessage);
        throw errorMessage;
      }).finally(() => {
        setIsCreatingBooking(false);
      });
  }, [bookingService, logger]);

  // Action: get existing booking list
  const getExistingBooking = useCallback((props) => {
    setIsGetExistingBookings(true);

    return bookingService.getExistingBookings(props).then((res) => {
      setExistingBookings(res);

      return res;
    }).catch((error) => {
      const errorCode = error && error.body && error.body.errorCode;
      const errorMessage = errorCodeMapping[errorCode] || _TL_('Request failed, please try later');
      setGetBookingError(errorMessage);

      logger.logError('Get existing bookings failed', errorMessage);
      throw errorMessage;
    }).finally(() => {
      setIsGetExistingBookings(false);
    });
  }, [bookingService, logger]);

  return {
    // create
    createBooking,
    isCreatingBooking,
    createBookingError,
    // get
    existingBookings,
    getExistingBooking,
    isGetExistingBookings,
    getBookingError,
  };
};
